// translations/pages/team/uk.js
// Texts of the team overview and of the navigation inside a profile. The
// profiles themselves come from src/profile (one folder per member).
export const teamPageUK = {
  hero: {
    title: 'Команда',
    intro: 'Adrian Eisenmeier та Nikolai Genov заснували pAIoneer Labs GmbH і очолюють її як керуючі директори.',
    members: 'Adrian Eisenmeier — дипломований фізик, який створює системи там, де поєднуються ШІ, архітектура програмного забезпечення, захист даних і безпека. Nikolai Genov — біоінформатик зі ступенем PhD і технічний керівник у сфері розробки програмного забезпечення з підтримкою ШІ та аналітики в регульованих галузях: охороні здоров’я, науках про життя та фінансах. Alina Tselinina — розробниця програмного забезпечення та інженерка даних зі ступенем магістра з фінансової та актуарної математики, яка розробляє застосунки, REST API та пайплайни даних на Python і R.'
  },
  card: {
    cta: 'Переглянути профіль'
  },
  profile: {
    overview: 'Команда',
    membersLabel: 'Члени команди'
  }
};
